export enum Variant {
	AchieveEarlyAccess = 'one-on-ones',
	AchieveLimitedRelease = 'achieve-limited-release',
}
